import { loader } from "graphql.macro";
import { useSelector } from "react-redux";
import { executeGraphqlMutation, executeGraphqlQuery } from "../../graphql/api";
import { CUSTOMER, NEW, RECEIVED, SEND, SNACKBAR } from "../../utils/constants";
import { addPinArchiveStatus, formatNewLinesInHtml, getAllConversationUnreadMsgCount, getPinnedConversations, isConversationViewer, twoStringsAreEqual } from "../../utils/utilities";
import { selectedConversation, updateMessagesById, updateConversations, updateParticipants, updateUnreadMsgCount, updatePage, updateInitialState, updateCustomerDetails } from "../action-creators/conversationActionCreator";
import { updateConversationsLoader, updateDashboardLoader, updateMessagesLoader } from "../action-creators/loaderActionCreators";
import snackbarOpen from "../action-creators/snackbarActionCreators";

const getUserDashboardConversationsQuery = loader(
    "../../graphql/queries/getUserDashboardConversations.graphql"
);

const getConversationsQuery = loader(
    "../../graphql/queries/getConversation.graphql"
);
const getMessagesQuery = loader(
    "../../graphql/queries/getMessages.graphql"
);
const getMessagesCountQuery = loader(
    "../../graphql/queries/getMessageCount.graphql"
);
const createConversationQuery = loader(
    "../../graphql/mutations/createConversation.graphql"
);
const createMessageQuery = loader(
    "../../graphql/mutations/createMessage.graphql"
);
const addParticipantQuery = loader(
    "../../graphql/mutations/addParticipant.graphql"
);
const deleteConversationQuery = loader(
    "../../graphql/mutations/deleteConversation.graphql"
);
const getParticipantQuery = loader(
    "../../graphql/queries/getParticipants.graphql"
);

const deleteParticipantQuery = loader(
    "../../graphql/mutations/deleteParticipant.graphql"
);

const updateLastSeenQuery = loader(
    "../../graphql/mutations/updateLastSeen.graphql"
);

const batchRemoveAdjuster = loader(
    "../../graphql/mutations/batchRemoveAdjuster.graphql"
);
const batchTransferAdjuster = loader(
    "../../graphql/mutations/batchTransferAdjuster.graphql"
);
const createCoverSchedule = loader(
    "../../graphql/mutations/createCoverSchedule.graphql"
);
const batchAddAdjuster = loader(
    "../../graphql/mutations/batchAddAdjuster.graphql"
);
const toggleArchiveConversation = loader(
    "../../graphql/mutations/toggleArchiveConversation.graphql"
);
const togglePinConversation = loader(
    "../../graphql/mutations/togglePinConversation.graphql"
);
const getCustomerDetails = loader(
    "../../graphql/queries/getCustomerContactDetails.graphql"
);


export default function fetchConversations(variables: any, callback?: (res: any) => any, errorCallback?: (error: any) => any) {
    return (dispatch: any, state: any) => {
        let store = state();
        executeGraphqlQuery(getConversationsQuery, { ...variables, index:store.chat.page, limit: store.chat.limit})
            .then((res: any) => {
                let conversationsResponse = res.data.getConversation;
                let formattedConversations: any = {};
                (store.chat.allConversations || []).forEach((c: any) => {
                    formattedConversations[c.conversationId] = addPinArchiveStatus(c, variables.adjusterId || store.user.email);
                });
                (conversationsResponse || []).forEach((c: any) => {
                    formattedConversations[c.conversationId] = addPinArchiveStatus(c, variables.adjusterId || store.user.email);
                });

                const updatedConversations = Object.values(formattedConversations);
                dispatch(updateConversations(updatedConversations));
                dispatch(updatePage(store.chat.page + 1));
                getAllConversationUnreadMsgCount(updatedConversations);
                callback && callback(updatedConversations);
            })
            .catch(error => {
                //toast message
                dispatch(updateConversationsLoader({ isLoading: false }))
                errorCallback && errorCallback(error);
                console.log(error);
            })
    }
}

export function fetchParticipants(conversationId: any, callback?: (res: any) => any, errorCallback?: (error: any) => any) {
    return (dispatch: any, state: any) => {
        let existingParticipants = state().chat.participants;
        executeGraphqlQuery(getParticipantQuery, { conversationId: conversationId })
            .then((res: any) => {
                let customer = res.data.getParticipants.find((participant: any) => participant.participantType === CUSTOMER);
                let updatedResponse = {
                    participants: res.data.getParticipants,
                    customer: customer
                }
                dispatch(updateParticipants({ [conversationId]: updatedResponse }));
            }, () => { })
    }
}

export function fetchCustomerDetails(claimNumber: any, contactId:any, conversationId:any) {
    return (dispatch: any, state: any) => {
    executeGraphqlQuery(getCustomerDetails, { claimNumber: claimNumber,contactId:contactId, conversationId:conversationId })
    .then((res: any) => {
        let customer = res.data.getContactInfo;
        dispatch(updateCustomerDetails(customer));
    })
    .catch(error => {
        console.log(error);
    })
}
}

export function fetchConversationById(variables: any, userId: any, callback?: (res: any) => any, errorCallback?: (error: any) => any) {
    executeGraphqlQuery(getConversationsQuery, { ...variables, limit: 1, index: 0 })
        .then((res: any) => {
            let conversationsResponse = res.data.getConversation && addPinArchiveStatus(res.data.getConversation[0], userId);
            callback && callback(conversationsResponse)
        })
        .catch(error => {
            //toast message
            errorCallback && errorCallback(error);
            console.log(error);
        })
}

export function fetchMessagesById(conversationId: any, callback?: (res: any) => any, errorCallback?: (error: any) => any) {
    return (dispatch: any, getState: any) => {
        let store = getState();
        let adjusterId = store.user.email;
        dispatch(updateMessagesLoader({ isLoading: true }))
        executeGraphqlQuery(getMessagesQuery, { conversationId: conversationId, adjusterId: adjusterId })
            .then((res: any) => {
                let messages = res.data.getMessages;
                let updatedMessages = messages.map((msg: any) => {
                    let type = twoStringsAreEqual(adjusterId, msg.from.id) ? SEND : RECEIVED;
                    return {
                        ...msg,
                        type: type,
                        message: formatNewLinesInHtml(msg.message)
                    }
                });
                dispatch(updateMessagesLoader({ isLoading: false }))
                callback && callback(updatedMessages)
                dispatch(updateMessagesById({ [conversationId]: updatedMessages.reverse() }));
            })
            .catch(error => {
                //toast message
                dispatch(updateMessagesLoader({ isLoading: false }))
                errorCallback && errorCallback(error)
                console.log(error);
            })
    }
}

export function fetchUnreadMessagesCountById(conversationId: any, callback?: (res: any) => any, errorCallback?: (error: any) => any) {
    return (dispatch: any, getState: any) => {
        let store = getState();
        let adjusterId = isConversationViewer() ? store.adjusters?.selectedAdjuster?.adjusterEmailId : store.user.email;
        executeGraphqlQuery(getMessagesCountQuery, { conversationId: conversationId, adjusterId: adjusterId })
            .then((res: any) => {
                let messages = res?.data?.getMessagesCount;
                dispatch(updateUnreadMsgCount({ [conversationId]: messages.count }))
                callback && callback(messages.count)
            })
            .catch(error => {
                //toast message
                errorCallback && errorCallback(error)
                console.log(error);
            })
    }

}

export function createConversation(createConversationInput: any, callback: (res: any) => any, errorCallback?: (error: any) => any) {
    return (dispatch: any, getStore: any) => {
        const { allConversations, selectedConversation } = getStore().chat;
        executeGraphqlMutation(createConversationQuery, createConversationInput)
            .then((res: any) => {
                let response = res.data.createConversation;
                if (response.message) {
                    throw new Error(response.message);
                } else {
                    let conversationResponse = { ...selectedConversation, ...res.data.createConversation, pinStatus: false, archiveStatus: false }
                    const pinnedConversations = getPinnedConversations();
                    let updatedConversations = allConversations.filter((item: any) => item.conversationId !== NEW)
                    dispatch(updateConversations([...pinnedConversations, conversationResponse, ...updatedConversations?.slice(pinnedConversations.length)]));
                    callback(conversationResponse)
                }
            })
            .catch(error => {
                dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
                errorCallback && errorCallback(error)
                console.log(error);
            })
    }
}

export function addParticipant(participantInput: any, callback: (res: any) => any) {
    return (dispatch: any) => {
        executeGraphqlMutation(addParticipantQuery, participantInput)
            .then((res: any) => {
                let addParticipantResponse = res.data.addParticipant;
                callback(addParticipantResponse);
            })
            .catch(error => {
                console.log(error);
                dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
            })
    }
}

export function createMessage(messageInput: any, callback?: (res: any) => any, errorCallback?: (error: any) => any) {
    return (dispatch: any, state: any) => {
        const apiRequests :any[]=[];
          messageInput.map((req:any)=>{
          apiRequests.push(executeGraphqlMutation(createMessageQuery, req))
        })
       // executeGraphqlMutation(createMessageQuery, messageInput)
        Promise.all(apiRequests)
            .then((res: any) => {       
                callback && callback(res);
            })
            .catch(error => {
                errorCallback && errorCallback(error)
                console.log(error);
                dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
            })
    }
}

export function deleteConversation(deleteConversationInput: any, callback: (res: any) => any, errorCallback: (error: any) => any) {
    executeGraphqlMutation(deleteConversationQuery, deleteConversationInput)
        .then((res: any) => {
            let deleteResponse = res.data.deleteConversation;
            callback(deleteResponse)
        })
        .catch(error => {
            errorCallback(error)
            console.log(error);
        })
}

export function deleteParticipant(deleteParticipantInput: any, callback?: (res: any) => any, errorCallback?: (error: any) => any) {
    return (dispatch: any, state: any) => {
        executeGraphqlMutation(deleteParticipantQuery, deleteParticipantInput)
            .then((res: any) => {
                callback && callback(res)
            })
            .catch(error => {
                errorCallback && errorCallback(error)
                dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
            })
    }
}

export function updateReadMessages(updateLastSeenInput: any) {
    return (dispatch: any) => {
        executeGraphqlMutation(updateLastSeenQuery, updateLastSeenInput)
            .then((res: any) => {
                dispatch(fetchUnreadMessagesCountById(updateLastSeenInput.conversationId));
            })
            .catch((error: any) => {
                dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
            })
    }
}

export function updateParticipantsSubscriptionData(updatedParticipantConversation: any) {
    return (dispatch: any, store: any) => {
        let chat = store().chat;
        let updatedConversations = chat.allConversations.map((con: any) => {
            return updatedParticipantConversation.conversationId === con.conversationId ? updatedParticipantConversation : con
        })
        dispatch(updateConversations(updatedConversations));
        if (chat.selectedConversation.conversationId === updatedParticipantConversation.conversationId) {
            dispatch(formatSelectedConversation(updatedParticipantConversation))
        }
    }

}

export function bulkRemoveAdjuster(batchUpdateConversationInput: any, callback: (response: any) => any, errorCallback: (error: any) => any) {
    return (dispatch: any, store: any) => {
        let user = store().user;
        dispatch(updateDashboardLoader({ isLoading: true }));
        executeGraphqlMutation(batchRemoveAdjuster, batchUpdateConversationInput)
            .then((res: any) => {
                let status = res.data.batchRemoveAdjuster;
                // dispatch(fetchConversations({ adjusterId: user.email }));
                dispatch(updateDashboardLoader({ isLoading: false }));
                callback(status);
            })
            .catch((error: any) => {
                errorCallback(error)
                dispatch(updateDashboardLoader({ isLoading: false }));
                dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
            })
    }

}


export function bulkTransferAdjuster(batchUpdateConversationInput: any, callback?: (response: any) => any, errorCallback?: (response: any) => any) {
    return (dispatch: any, store: any) => {
        let user = store().user;
        dispatch(updateDashboardLoader({ isLoading: true }));
        executeGraphqlMutation(batchTransferAdjuster, batchUpdateConversationInput)
            .then((res: any) => {
                let status = res.data.batchTransferAdjuster;
                // dispatch(fetchuser({ adjusterId: user.email }));
                dispatch(updateDashboardLoader({ isLoading: false }));
                callback && callback(status);
            })
            .catch((error: any) => {
                errorCallback && errorCallback(error)
                dispatch(updateDashboardLoader({ isLoading: false }));
                dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
            })
    }
}

export function bulkCoverAdjuster(createCoverScheduleInput: any, callback?: (response: any) => any, errorCallback?: (response: any) => any) {
    return (dispatch: any, store: any) => {
        let user = store().user;
        dispatch(updateDashboardLoader({ isLoading: true }));
        executeGraphqlMutation(createCoverSchedule, createCoverScheduleInput)
            .then((res: any) => {
                let status = res.data.createCoverSchedule;
                // dispatch(fetchuser({ adjusterId: user.email }));
                dispatch(updateDashboardLoader({ isLoading: false }));
                callback && callback(status);
            })
            .catch((error: any) => {
                errorCallback && errorCallback(error)
                dispatch(updateDashboardLoader({ isLoading: false }));
                dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
            })
    }
}


export function bulkAddAdjuster(batchUpdateConversationInput: any, callback?: (response: any) => any, errorCallback?: (response: any) => any) {
    return (dispatch: any, store: any) => {
        let user = store().user;
        dispatch(updateDashboardLoader({ isLoading: true }));
        executeGraphqlMutation(batchAddAdjuster, batchUpdateConversationInput)
            .then((res: any) => {
                let status = res.data.batchAddAdjuster;
                // dispatch(fetchConversations({ adjusterId: user.email }));
                dispatch(updateDashboardLoader({ isLoading: false }));
                callback && callback(status);
            })
            .catch((error: any) => {
                errorCallback && errorCallback(error)
                dispatch(updateDashboardLoader({ isLoading: false }));
                dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
            })
    }
}

export function fetchUserDashboardConversations(myConversationsInput: any, callback?: (response: any) => any, errorCallback?: (error: any) => any) {
    executeGraphqlMutation(getUserDashboardConversationsQuery, myConversationsInput)
        .then((res: any) => {
            let status = res.data.myConversations;
            callback && callback(status);
        })
        .catch((error: any) => {
            errorCallback && errorCallback(error);
        })
}

export function updateArchiveConversation(input: any, callback?: (response: any) => any, errorCallback?: (error: any) => any) {
    return (dispatch: any, store: any) => {
        let { allConversations } = store().chat;
        executeGraphqlMutation(toggleArchiveConversation, input)
            .then((res: any) => {
                let status = res.data.archiveConversation;
                let filteredConversations = (allConversations || []).filter((con: any) => con.conversationId !== input.conversationId);
                dispatch(updateConversations([...filteredConversations]));
                if (filteredConversations.length > 0) {
                    dispatch(formatSelectedConversation(filteredConversations[0]));
                } else {
                    dispatch(formatSelectedConversation(null));
                }
                callback && callback(status);
            })
            .catch((error: any) => {
                errorCallback && errorCallback(error)
                dispatch(updateDashboardLoader({ isLoading: false }));
                dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
            })
    }
}


export function updatePinConversation(input: any, callback?: (response: any) => any, errorCallback?: (error: any) => any) {
    return (dispatch: any, store: any) => {
        let { allConversations, selectedConversation } = store().chat;
        let user = store().user;
        executeGraphqlMutation(togglePinConversation, input)
            .then((res: any) => {
                let status = res.data.pinConversation;
                dispatch(updateInitialState())
                dispatch(updateConversationsLoader({ isLoading: true }))
                dispatch(fetchConversations({ adjusterId: user.email ,isArchived: false}, (res) => {
                    dispatch(formatSelectedConversation(res[0]))
                    dispatch(updateConversationsLoader({ isLoading: false }))
                }))
                callback && callback(status);
            })
            .catch((error: any) => {
                errorCallback && errorCallback(error)
                dispatch(updateDashboardLoader({ isLoading: false }));
                dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
            })
    }
}

export function formatSelectedConversation(conversation: any) {
    return (dispatch: any) => {
        if (conversation !== null) {
            dispatch(selectedConversation({ ...conversation }))
        }
        else {
            dispatch(selectedConversation(null))
        }
    }
}